import Vue from 'vue'
import Router from 'vue-router'
import LoginComponent from '@/components/LoginComponent'
import AppComponent from '@/components/AppComponent'
import {store} from '../store/index.js'

Vue.use(Router)

var instance = this

export default new Router({
	routes: [
		{
			path: '/',
			name: 'LoginComponent',
			component: LoginComponent
		},
		{
			path: '/app',
			name: 'AppComponent',
			component: AppComponent,
			beforeEnter: (to, from, next) => {
				console.log(findGetParameter())
				if (store.state.user) next()
				else next({path: '/', query: { v: window.location.href.split("v=") ? window.location.href.split("v=")[1] : null }})
			}
		}
	]
})

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}


// WEBPACK FOOTER //
// ./src/router/index.js